module.exports = __webpack_public_path__ + "7bf72df32a85fdf5d25ddc2d09390de1.png";